export const SELECT_THEME = {
  defaultProps: {
    variant: "filled",
  },
};
